module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_7042.581fb8a3.png";